import Axios from 'axios'

import config from '@/config'
import stores from '@/stores'
import storage from '@/utils/storage'
import { toast } from 'react-toastify'

import ToastErrorMessage from '@/components/Elements/ToastErrorMessage'
import { logout } from '@/stores/auth/authSlice'

// Function to perform health-check
async function healthCheck() {
  try {
    const response = await Axios.get(`${config.apiURL}/health-check`) // Replace `/health-check` with your actual health-check endpoint
    return response.status === 200
  } catch (error) {
    return false
  }
}

// Axios instance
export const axios = Axios.create({
  baseURL: config.apiURL,
})

// Request interceptor to include auth headers
function authRequestInterceptor(config) {
  const token = storage.getToken()

  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
      'Access-Control-Allow-Origin': '*',
    }
  }

  return config
}

// Attach the request interceptor
axios.interceptors.request.use(authRequestInterceptor)

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const errorResponseObj = error?.response?.data
    const logoutDispatch = () => stores.dispatch(logout())

    console.log('AXios: ', errorResponseObj)
    // console.log(error.response?.status)

    const isHealthy = await healthCheck()

    if (!isHealthy) {
      // window.location.href = '/maintenance'
      return Promise.reject(new Error('Server is under maintenance. Redirecting to maintenance page.'))
    }

    // if(errorResponseObj?.message && errorResponseObj?.message.includes('BSONObj')) {
    //   return Promise.reject(error)
    // }

    console.log('errorResponseObj', errorResponseObj)

    if (errorResponseObj) {
      switch (error.response?.status) {
        case 404:
          break
        case 500:
        case 422:
          if (errorResponseObj?.type && Array.isArray(errorResponseObj?.details)) {
            toast.error(<ToastErrorMessage details={errorResponseObj?.details} />)
          } else if (errorResponseObj?.type === 'Zod Error' && Array.isArray(errorResponseObj?.stack)) {
            toast.error(<ToastErrorMessage issues={errorResponseObj?.stack} />)
          } else if (
            errorResponseObj?.type === 'MISSING_SIGNATURE' ||
            errorResponseObj?.type === 'MISSING_SIGNATURE_LABEL'
          ) {
            // The calling mutation shows its own signature prompt, so skip the generic toast.
          } else if (!errorResponseObj.data) {
            toast.error(errorResponseObj?.message || 'Some error happened...')
          }

          break
        case 401:
          logoutDispatch()
          toast.info('Please login to see the requested page!')
          break
        default:
          console.log(error.response?.status)
          break
      }
    }
    return Promise.reject(error)
  }
)
